import { combineReducers } from "@reduxjs/toolkit";

import authentication from "./auth/authentication";
import resetPassword from "./auth/resetPassword";
import myProfile from "./profile/myProfile";
import transactions from "./profile/transactions";
import toast from "./toast";
import casinoLobby from "./casino/lobby/casinoLobby";
import casinoGames from "./casino/lobby/casinoGames";
import cms from "./cms";
import payment from "./payment";
import bonus from "./casino/lobby/bonus";
import faq from "./Faq";
// import coinbetFriend from "./coinbetfriends";
import settings from "./settings";
import favorites from "./casino/lobby/favorites";
import supportmodal from "./support/chatsupport";
import sportsBanner from "./sportsBanner";
import sportReducerNode from "../../sportbookNode-saga/redux";
import fifaReducer from "./fifa";
import notifications from "./notifications/notifications";

const rootReducer = combineReducers({
  authentication,
  myProfile,
  transactions,
  toast,
  payment,
  resetPassword,
  casinoLobby,
  casinoGames,
  cms,
  bonus,
  faq,
  // coinbetFriend,
  settings,
  favorites,
  supportmodal,
  sportsBanner,
  sportbook: sportReducerNode,
  fifa: fifaReducer,
  notifications,
});

export default rootReducer;
